import React, { useCallback, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import AppLink from '../../../../../components/AppLink';
import { ReactComponent as ChooseArrowsImg } from '../images/choose_arrows.svg';
import { getDataAboutSelectedForAllSections } from '../utils/getDataAboutSelectedForAllSections';
import * as cl from './ChooseSelect.module.scss';

function getButtonLabel(pos) {
  if (pos === -1) return 'Restart Learning'
  if (pos > 0) return 'Continue Learning'
  if (pos === -2) return 'Empty'
  return 'Start Learning'
}

const ChooseSelect = ({ currentBlockName, state, changeSelect, onNoAccessClick, access }) => {
  const { url } = useRouteMatch();
  const [buttonLabel, setButtonLabel] = useState('Start Learning')
  const [buttonLink, setButtonLink] = useState('')
  const [hasAccess, setHasAccess] = useState(false)

  const changeChoose = useCallback(() => {
    const nextLessonPos = getDataAboutSelectedForAllSections(state)
    const btnLabel = getButtonLabel(nextLessonPos.pos);

    setButtonLabel(btnLabel)
    setButtonLink(nextLessonPos.postName)
    setHasAccess(nextLessonPos.hasAccess)
  }, [state]);

  useEffect(() => {
    changeChoose(currentBlockName)
  }, [changeChoose, currentBlockName])

  function handleClick() {
    sendButtonClickToAnalytics();
    onNoAccessClick(access);
  }

  const sendButtonClickToAnalytics = () => {
        // actid=12
        window.analytics?.track("button:click", {
          "button_name": "Continue learning",
          "parent_object_title": currentBlockName,
          "url": url
        });
  };

  return (
    <div className={cl.choose_lesson}>
      <div className={cl.choose_lesson__select}>
        <select
          value={currentBlockName}
          name="select_lesson"
          id="select_lesson"
          className={cl.choose_lesson__choice}
          onChange={(e) => changeSelect(e.target.value)}
        >
          {Object.values(state).map((item, index) => (
            <option value={item.title} key={index}>{item.title} {item.video_length && `(${item.video_length})`}</option>
          ))}
        </select>
        <ChooseArrowsImg/>
      </div>

      {hasAccess ? (
        <AppLink to={`${url}${buttonLink}/`} className={cl.choose_lesson__btn} onClick={sendButtonClickToAnalytics}>{buttonLabel}</AppLink>
      ) : (
        <button type="button" className={cl.choose_lesson__btn} onClick={handleClick}>{buttonLabel}</button>
      )}
    </div>
  );
};

export default ChooseSelect;
